"use client";

import type { ComponentProps, ReactNode } from "react";

import { cn } from "@/lib/cn";

export interface HeaderShellProps extends ComponentProps<"header"> {
  children: ReactNode;
  variant?: "sticky" | "static";
}

const Root = ({
  children,
  className,
  variant = "sticky",
  ...rest
}: HeaderShellProps) => (
  <header
    className={cn(
      "sdkui:z-49 sdkui:w-full sdkui:border-b sdkui:backdrop-blur-2xl",
      variant === "sticky" && "sdkui:fixed sdkui:top-0 sdkui:left-0",
      className
    )}
    {...rest}
  >
    <div className="sdkui:flex sdkui:h-16 sdkui:w-full sdkui:items-center sdkui:justify-between sdkui:gap-3 sdkui:px-4 sdkui:md:h-18 sdkui:md:px-6">
      {children}
    </div>
  </header>
);

const Left = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <div
    className={cn(
      "sdkui:flex sdkui:min-w-0 sdkui:items-center sdkui:gap-1 sdkui:md:gap-2 sdkui:lg:flex-1",
      className
    )}
  >
    {children}
  </div>
);

const Center = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <div
    className={cn(
      "sdkui:hidden sdkui:min-w-0 sdkui:flex-1 sdkui:md:block",
      className
    )}
  >
    {children}
  </div>
);

const Right = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <div
    className={cn(
      "sdkui:flex sdkui:min-w-0 sdkui:items-center sdkui:justify-end sdkui:gap-1 sdkui:md:gap-2 sdkui:lg:flex-1",
      className
    )}
  >
    {children}
  </div>
);

export const HeaderShell = Object.assign(Root, { Left, Center, Right });
